import { Policy } from '@commandDrivenStateEngine/core/policies';
import { NavbarState } from '../state';
import { NavbarCommand } from '../commands';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
/**
 * Account Subscription Policy
 *
 * Responsibilities:
 * - Subscribe to AccountsReadmodelType on init
 * - Dispatch account update commands when data changes
 * - Cleanup subscription on unmount
 */
export const createAccountSubscriptionPolicy = (
  backend: ClientLibraryType
): Policy<NavbarState, NavbarCommand> => ({
  name: 'navbar-account-subscription',

  init: ({ dispatch }) => {
    console.log( '[navbar] Initializing account subscription' );

    const close = backend.subscriptions.AccountsReadmodel(
      {},
      ( accountChange: any ) => {
        // Snapshot: full state initialization from subscription
        if ( accountChange?.type === 'snapshot' ) {
          const account = accountChange.data.items[0];
          if ( account ) {
            dispatch(
              {
                type: 'navbar/account/update',
                payload: {
                  name: account.accountName || null,
                  data: account
                }
              },
              { source: 'api' }
            );
          }
          return;
        }

        if ( accountChange?.data ) {
          dispatch(
            {
              type: 'navbar/account/update',
              payload: {
                name: accountChange.data.accountName || null,
                data: accountChange.data
              }
            },
            { source: 'api' }
          );
        }
      }
    );

    // Cleanup function
    return () => {
      console.log( '[navbar] Closing account subscription' );
      close.close();
    };
  }
});
